import React, { useState } from 'react';
import { Navbar } from './Navbar';
import { Hero } from './sections/Hero';
import { Problema } from './sections/Problema';
import { Solucion } from './sections/Solucion';
import { ComoFunciona } from './sections/ComoFunciona';
import { Transformacion } from './sections/Transformacion';
import { Aprenderas } from './sections/Aprenderas';
import { Oferta } from './sections/Oferta';
import { Bonos } from './sections/Bonos';
import { Testimonios } from './sections/Testimonios';
import { Creador } from './sections/Creador';
import { Garantia } from './sections/Garantia';
import { FAQ } from './sections/FAQ';
import { CTAFinal } from './sections/CTAFinal';
import { Footer } from './Footer';
import { StickyBar } from './StickyBar';
import { QuizModal } from './QuizModal';
export function SalesPage() {
  const [isQuizOpen, setIsQuizOpen] = useState(false);
  return <main className="relative bg-deep min-h-screen" data-id="element-40">
      <Navbar data-id="element-41" />
      <Hero onOpenQuiz={() => setIsQuizOpen(true)} data-id="element-42" />
      <Problema data-id="element-43" />
      <Solucion data-id="element-44" />
      <ComoFunciona data-id="element-45" />
      <Transformacion data-id="element-46" />
      <Aprenderas data-id="element-47" />
      <Oferta data-id="element-48" />
      <Bonos data-id="element-49" />
      <Testimonios data-id="element-50" />
      <Creador data-id="element-51" />
      <Garantia data-id="element-52" />
      <FAQ data-id="element-53" />
      <CTAFinal data-id="element-54" />
      <Footer data-id="element-55" />

      <StickyBar data-id="element-56" />
      <QuizModal isOpen={isQuizOpen} onClose={() => setIsQuizOpen(false)} data-id="element-57" />
    </main>;
}